import { render, staticRenderFns } from "./configChangeStatis.vue?vue&type=template&id=099a632c&scoped=true&"
import script from "./configChangeStatis.vue?vue&type=script&lang=js&"
export * from "./configChangeStatis.vue?vue&type=script&lang=js&"
import style0 from "./configChangeStatis.vue?vue&type=style&index=0&id=099a632c&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "099a632c",
  null
  
)

export default component.exports